import { useState } from 'react'
import * as Yup from 'yup'
import notify from 'components/atoms/Notify'
import apiPost from 'lib/network/apiPost'

const balanceSchema = Yup.object().shape({
  type: Yup.string().oneOf(['credit', 'debit'], 'Invalid type').required('Adjustment type is required'),
  balance: Yup.number().typeError('Amount must be a number').positive('Amount must be greater than zero').required('Amount is required'),
  reason: Yup.string().required('Reason is required'),
})

const AddBalance = ({ onSuccess, close, userId }) => {
  const [formData, setFormData] = useState({
    type: 'credit',
    balance: '',
    reason: '',
  })
  const [errors, setErrors] = useState({})
  const [loading, setLoading] = useState(false)

  const handleChange = e => {
    const { name, value } = e.target
    setFormData(prev => ({ ...prev, [name]: value }))
    setErrors(prev => ({ ...prev, [name]: '' }))
  }

  const handleAddUserBalance = async () => {
    try {
      setLoading(true)
      await balanceSchema.validate(formData, { abortEarly: false })
      const response = await apiPost(`wallet/balance/${userId}`, formData)
      if (response.success) {
        notify.success('Wallet balance updated successfully')
        onSuccess(response.data?._id)
      } else {
        notify.error(response.message || 'Failed to update wallet balance')
      }
    } catch (validationError) {
      if (validationError.inner) {
        const newErrors = {}
        // eslint-disable-next-line
        validationError.inner.forEach(err => {
          newErrors[err.path] = err.message
        })
        setErrors(newErrors)
      }
    } finally {
      setLoading(false)
    }
  }

  return (
    <div>
      <div className="mb-4">
        <label htmlFor="type" className="block text-sm font-medium text-gray-700 mb-1">
          Adjustment type
        </label>
        <select
          name="type"
          id="type"
          value={formData.type}
          onChange={handleChange}
          className="block w-full h-[38px] rounded-md border border-gray-300 shadow-sm sm:text-sm focus:ring-dark-500 focus:border-dark-500 px-3"
        >
          <option value="credit">Credit</option>
          <option value="debit">Debit</option>
        </select>
        {errors.type && <p className="text-sm text-red-600 mt-1">{errors.type}</p>}
      </div>

      <div className="mb-4">
        <label htmlFor="balance" className="block text-sm font-medium text-gray-700 mb-1">
          Amount
        </label>
        <input
          type="number"
          name="balance"
          id="balance"
          value={formData.balance}
          onChange={handleChange}
          className="block w-full rounded-md border-gray-300 shadow-sm sm:text-sm focus:ring-dark-500 focus:border-dark-500"
          placeholder="OMR 0.00"
        />
        {errors.balance && <p className="text-sm text-red-600 mt-1">{errors.balance}</p>}
      </div>

      <div className="mb-4">
        <label htmlFor="reason" className="block text-sm font-medium text-gray-700 mb-1">
          Add internal note
        </label>
        <textarea
          name="reason"
          id="reason"
          rows={3}
          value={formData.reason}
          onChange={handleChange}
          className="block w-full rounded-md border-gray-300 shadow-sm sm:text-sm focus:ring-dark-500 focus:border-dark-500"
          placeholder="Enter reason for adjustment"
        />
        {errors.reason && <p className="text-sm text-red-600 mt-1">{errors.reason}</p>}
      </div>

      <div className="mt-4 flex justify-end">
        <button
          type="button"
          disabled={loading}
          onClick={handleAddUserBalance}
          className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm text-white bg-dark-600 hover:bg-dark-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-dark-500"
        >
          {loading ? 'Processing...' : 'Submit'}
        </button>
        <button
          type="button"
          className="ml-2 inline-flex justify-center rounded-md border border-transparent bg-gray-100 px-4 py-2 text-sm font-medium text-gray-900 hover:bg-gray-200"
          onClick={close}
          disabled={loading}
        >
          Close
        </button>
      </div>
    </div>
  )
}

export default AddBalance
